module.exports = __webpack_public_path__ + "static/media/stadium.8dc90b89.jpg";